module.exports = __webpack_public_path__ + "img/itx-file-type-avi.27e8b92d.svg";